<ww-grid [gridData]="amountRAMService.dashBoardMeasure" [allowDeleting]="false" [allowUpdating]="false" class="grid-group-by-style"
    [height]="'300px'" [id]="'measureDashboardGrid'" [enableColumnChooser]="false" [filterPanel]="false"
    [groupable]="false" [enableExport]="false" [searchPanel]="false" [groupingContextMenu]="false" (onCellPrepared)="onCellPrepared($event)"
    [columnsHeader]="riskAssesmentMeasureColumns" [allowAdding]="false" [enableHeaderFilter]="false">
</ww-grid>
